export const TOAST_CONSTANTS_MEETING = 'meeting';
export const TOAST_CONSTANTS_CHAT = 'chat';
